// extracted by mini-css-extract-plugin
export default {"langDropdown":"LanguagePicker_langDropdown__bYSx8","langOption":"LanguagePicker_langOption__ozD9A","check":"LanguagePicker_check__ud-Fr"};